import language from '@/plugins/language';

function get(key) {
  return language.get(key);
}
export default {
  get,
  install(Vue) {
    Vue.filter('lang', get);
  },
};
